import React from 'react';
import TermsOfService from './TermsOfService.md';
import ReactMarkdown from 'react-markdown'
import {Box} from "@mui/material";
import {Helmet} from "react-helmet";

function Terms(){
    return (
           <Box margin={"25px"} marginBottom={"75px"}>
               <Helmet>
                   <title>PairCare - Terms of Service</title>
               </Helmet>
               <Box style={{marginLeft:"auto", marginRight:"auto",  maxWidth:"750px"}}>
                    <ReactMarkdown>{TermsOfService}</ReactMarkdown>
               </Box>
           </Box>
    );
}

export default Terms;